export default "__VITE_PUBLIC_ASSET__8bbb36cc__"